export const PATH_DICTIONARY = {
  home: '/',
  login: '/login',
  loginByToken: '/login-by-token',
  changePassword: '/change-password',
};
